const axles = [
    {
        "id": 1,
        "name": "2 Axle",
        "filedid": "2",
        "products": [
            {
                "id": 1,
                "name": "Volvo prime movers",
                "capacity": "150 MT puller",
                "quantity": "2 nos.",
                "details": "FH 520 HP",
                "Image": "/product/axles/2/axle (1).jfif"
            },
            {
                "id": 2,
                "name": "Volvo prime movers",
                "capacity": "120 MT puller",
                "quantity": "4 nos.",
                "details": "FH 400 HP",
                "Image": "/product/axles/2/axle (2).jfif"
            },
            {
                "id": 3,
                "name": "Man prima mover",
                "capacity": "80 MT puller",
                "quantity": "1 no.",
                "details": "280 HP",
                "Image": "/product/axles/2/axle (3).jfif"
            },
            {
                "id": 4,
                "name": "TATA Prima Puller",
                "capacity": "80 MT puller",
                "quantity": "2 Nos.",
                "details": "280 HP",
                "Image": "/product/axles/2/axle (4).jfif"
            },
            {
                "id": 5,
                "name": "Hydraulic Axles (TRATEC)",
                "capacity": "18 MT per axle",
                "quantity": "54 No.",
                "details": "Axles",
                "Image": "/product/axles/2/axle (5).jfif"
            },
            {
                "id": 6,
                "name": "Hydraulic axles (Goldhofer)",
                "capacity": "26 MT per axle",
                "quantity": "24 No.",
                "details": "Axles",
                "Image": "/product/axles/2/axle (6).jfif"
            },
            {
                "id": 7,
                "name": "Telescopic spacer beam",
                "capacity": "50 feet",
                "quantity": "1 no.",
                "details": "compatible for tratec as well as goldhofer",
                "Image": "/product/axles/2/axle (7).jfif"
            },
            {
                "id": 8,
                "name": "Bolsters",
                "capacity": "-",
                "quantity": "2 sets",
                "details": "-",
                "Image": "/product/axles/2/axle (8).jfif"
            },
            {
                "id": 9,
                "name": "Stands",
                "capacity": "-",
                "quantity": "50 No.",
                "details": "-",
                "Image": "/product/axles/2/axle (9).jfif"
            },
            {
                "id": 10,
                "name": "Beams",
                "capacity": "-",
                "quantity": "20 No.",
                "details": "-",
                "Image": "/product/axles/2/axle (10).jfif"
            }
        ]
    },
    {
        "id": 2,
        "name": "3 Axle",
        "filedid": "3",
        "products": [
            {
                "id": 1,
                "name": "Volvo prime movers",
                "capacity": "150 MT puller",
                "quantity": "2 nos.",
                "details": "FH 520 HP",
                "Image": "/product/axles/3/axle (1).jfif"
            },
            {
                "id": 2,
                "name": "Volvo prime movers",
                "capacity": "120 MT puller",
                "quantity": "4 nos.",
                "details": "FH 400 HP",
                "Image": "/product/axles/3/axle (2).jfif"
            },
            {
                "id": 3,
                "name": "Man prima mover",
                "capacity": "80 MT puller",
                "quantity": "1 no.",
                "details": "280 HP",
                "Image": "/product/axles/3/axle (3).jfif"
            },
            {
                "id": 4,
                "name": "TATA Prima Puller",
                "capacity": "80 MT puller",
                "quantity": "2 Nos.",
                "details": "280 HP",
                "Image": "/product/axles/3/axle (4).jfif"
            },
            {
                "id": 5,
                "name": "Hydraulic Axles (TRATEC)",
                "capacity": "18 MT per axle",
                "quantity": "54 No.",
                "details": "Axles",
                "Image": "/product/axles/3/axle (5).jfif"
            },
            {
                "id": 6,
                "name": "Hydraulic axles (Goldhofer)",
                "capacity": "26 MT per axle",
                "quantity": "24 No.",
                "details": "Axles",
                "Image": "/product/axles/3/axle (6).jfif"
            },
            {
                "id": 7,
                "name": "Telescopic spacer beam",
                "capacity": "50 feet",
                "quantity": "1 no.",
                "details": "compatible for tratec as well as goldhofer",
                "Image": "/product/axles/3/axle (7).jfif"
            },
            {
                "id": 8,
                "name": "Bolsters",
                "capacity": "-",
                "quantity": "2 sets",
                "details": "-",
                "Image": "/product/axles/3/axle (8).jfif"
            },
            {
                "id": 9,
                "name": "Stands",
                "capacity": "-",
                "quantity": "50 No.",
                "details": "-",
                "Image": "/product/axles/3/axle (9).jfif"
            },
            {
                "id": 10,
                "name": "Beams",
                "capacity": "-",
                "quantity": "20 No.",
                "details": "-",
                "Image": "/product/axles/3/axle (10).jfif"
            }
        ]
    },
    {
        "id": 3,
        "name": "4 Axle",
        "filedid": "4",
        "products": [
            {
                "id": 1,
                "name": "Volvo prime movers",
                "capacity": "150 MT puller",
                "quantity": "2 nos.",
                "details": "FH 520 HP",
                "Image": "/product/axles/4/axle (1).jfif"
            },
            {
                "id": 2,
                "name": "Volvo prime movers",
                "capacity": "120 MT puller",
                "quantity": "4 nos.",
                "details": "FH 400 HP",
                "Image": "/product/axles/4/axle (2).jfif"
            },
            {
                "id": 3,
                "name": "Man prima mover",
                "capacity": "80 MT puller",
                "quantity": "1 no.",
                "details": "280 HP",
                "Image": "/product/axles/4/axle (3).jfif"
            },
            {
                "id": 4,
                "name": "TATA Prima Puller",
                "capacity": "80 MT puller",
                "quantity": "2 Nos.",
                "details": "280 HP",
                "Image": "/product/axles/4/axle (4).jfif"
            },
            {
                "id": 5,
                "name": "Hydraulic Axles (TRATEC)",
                "capacity": "18 MT per axle",
                "quantity": "54 No.",
                "details": "Axles",
                "Image": "/product/axles/4/axle (5).jfif"
            },
            {
                "id": 6,
                "name": "Hydraulic axles (Goldhofer)",
                "capacity": "26 MT per axle",
                "quantity": "24 No.",
                "details": "Axles",
                "Image": "/product/axles/4/axle (6).jfif"
            },
            {
                "id": 7,
                "name": "Telescopic spacer beam",
                "capacity": "50 feet",
                "quantity": "1 no.",
                "details": "compatible for tratec as well as goldhofer",
                "Image": "/product/axles/4/axle (7).jfif"
            },
            {
                "id": 8,
                "name": "Bolsters",
                "capacity": "-",
                "quantity": "2 sets",
                "details": "-",
                "Image": "/product/axles/4/axle (8).jfif"
            },
            {
                "id": 9,
                "name": "Stands",
                "capacity": "-",
                "quantity": "50 No.",
                "details": "-",
                "Image": "/product/axles/4/axle (9).jfif"
            },
            {
                "id": 10,
                "name": "Beams",
                "capacity": "-",
                "quantity": "20 No.",
                "details": "-",
                "Image": "/product/axles/4/axle (10).jfif"
            }
        ]
    },
    {
        "id": 4,
        "name": "6 Axle",
        "filedid": "6",
        "products": [
            {
                "id": 1,
                "name": "Volvo prime movers",
                "capacity": "150 MT puller",
                "quantity": "2 nos.",
                "details": "FH 520 HP",
                "Image": "/product/axles/6/axle (1).jfif"
            },
            {
                "id": 2,
                "name": "Volvo prime movers",
                "capacity": "120 MT puller",
                "quantity": "4 nos.",
                "details": "FH 400 HP",
                "Image": "/product/axles/6/axle (2).jfif"
            },
            {
                "id": 3,
                "name": "Man prima mover",
                "capacity": "80 MT puller",
                "quantity": "1 no.",
                "details": "280 HP",
                "Image": "/product/axles/6/axle (3).jfif"
            },
            {
                "id": 4,
                "name": "TATA Prima Puller",
                "capacity": "80 MT puller",
                "quantity": "2 Nos.",
                "details": "280 HP",
                "Image": "/product/axles/6/axle (4).jfif"
            },
            {
                "id": 5,
                "name": "Hydraulic Axles (TRATEC)",
                "capacity": "18 MT per axle",
                "quantity": "54 No.",
                "details": "Axles",
                "Image": "/product/axles/6/axle (5).jfif"
            },
            {
                "id": 6,
                "name": "Hydraulic axles (Goldhofer)",
                "capacity": "26 MT per axle",
                "quantity": "24 No.",
                "details": "Axles",
                "Image": "/product/axles/6/axle (6).jfif"
            },
            {
                "id": 7,
                "name": "Telescopic spacer beam",
                "capacity": "50 feet",
                "quantity": "1 no.",
                "details": "compatible for tratec as well as goldhofer",
                "Image": "/product/axles/6/axle (7).jfif"
            },
            {
                "id": 8,
                "name": "Bolsters",
                "capacity": "-",
                "quantity": "2 sets",
                "details": "-",
                "Image": "/product/axles/6/axle (8).jfif"
            },
            {
                "id": 9,
                "name": "Stands",
                "capacity": "-",
                "quantity": "50 No.",
                "details": "-",
                "Image": "/product/axles/6/axle (9).jfif"
            },
            {
                "id": 10,
                "name": "Beams",
                "capacity": "-",
                "quantity": "20 No.",
                "details": "-",
                "Image": "/product/axles/6/axle (10).jfif"
            }
        ]
    }
];
export default axles;